import {
    CONTRIBUTION_TYPE_DONATED_TIME,
    CONTRIBUTION_TYPE_FLAT,
    CONTRIBUTION_TYPE_HOURLY,
    CONTRIBUTION_TYPE_REIMBURSEMENT,
    CONTRIBUTION_TYPE_SALARIED_HOURLY,
    RATE_TYPE_FLAT,
    RATE_TYPE_HOURLY,
    RATE_TYPE_NO_FEE,
    RATE_TYPE_SLIDING_HOURLY,
    RATE_TYPE_TBD,
} from '@evencel/api';
import {DateTime} from 'luxon';
import {IBaseSchema} from '../../base.schema';
import {ISelectItem} from '../../drop-down';
import {IParticipantSelect} from '../participant';
import {IUserSelect} from '../user';
import {IActivity} from './activity';
import {ISessionWriteUp} from './activity-data.interface';

export interface IActionStep extends ISelectItem {
    activityTypes: string[];
}

export interface IAction extends IBaseSchema {
    /** Computed action name for the Select  */
    label?: string;
    _id?: string;
    step: IActionStep;
    date: Date;
    duration?: number;
    startTime?: string;
    medium?: ISelectItem;
    location?: ISelectItem;
    language?: ISelectItem;
    interpreter?: boolean;
    interpreterType?: ISelectItem;
    interpreterLanguages?: ISelectItem;
    interpreterComments?: string;
    users: IUserSelect[];
    participants?: IParticipantSelect[];
    numberOfParticipants?: number;
    status: ISelectItem;
    remarks?: string;
    canceledDate?: Date;
    additionalSessionsRequested?: boolean;
    additionalSessionsComment?: string;
    //
    scheduled?: boolean;
    scheduleDate?: Date;
    timeSpentOnScheduling?: number;
    userNotifyViaEmail?: boolean;
    participantNotifyViaEmail?: boolean;
    // PMP
    pmpCase?: boolean;
    pmpEligibility?: boolean;
    pmpDuration?: number;
    pmpTimeUsed?: number;
    pmpTimeApproved?: number;
    cp?: boolean;
    ncp?: boolean;
    //
    activity?: IActivity;
}

export interface IActionCreated extends IAction {
    _id: string;
}

export function getActionPmpTime(actions?: IAction[]) {
    return actions?.map(a => a.pmpDuration || 0).reduce((a, b) => a + b, 0);
}

export function getPmpDuration(activity?: IActivity) {
    const actionDuration = getActionPmpTime(activity?.actions);
    const writeUp = activity?.activityData?.divorceAndFamilyPmp?.sessionWriteUps;
    if (writeUp && actionDuration) {
        return getPpmTimeUsed(actionDuration, writeUp);
    }
    return 0;
}

function getPpmTimeUsed(actionTime: number, writeUpTimes: ISessionWriteUp[] | null): number {
    let wpt = 0;
    if (writeUpTimes) {
        wpt = writeUpTimes.map(h => h.time || 0).reduce((a, o) => +a + +o, 0);
    }
    return wpt + actionTime;
}

export function getActionLabelForSelect(action: IAction) {
    const d = new Date(action.date);
    let dateString = DateTime.fromJSDate(d).toFormat('MM/dd/yyyy');
    if (typeof action.date == 'string') {
        dateString = getUTCTime(action.date);
    }
    return `${dateString} - ${action.step.label}`;
}

export function getUTCTime(date: string) {
    return DateTime.fromISO(date, {zone: 'utc'}).toFormat('MM/dd/yyyy');
}

export function calculateSubTotal(rateType: ISelectItem, duration: number, rate: number) {
    let subTotal = 0;
    if (rateType) {
        switch (rateType._id) {
            case RATE_TYPE_HOURLY._id:
            case RATE_TYPE_SLIDING_HOURLY._id:
            case CONTRIBUTION_TYPE_HOURLY._id:
                {
                    subTotal = duration * rate;
                }
                break;
            case RATE_TYPE_NO_FEE._id:
            case RATE_TYPE_TBD._id:
            case CONTRIBUTION_TYPE_DONATED_TIME._id:
            case CONTRIBUTION_TYPE_SALARIED_HOURLY._id:
                break;
            case RATE_TYPE_FLAT._id:
            case CONTRIBUTION_TYPE_FLAT._id:
            case CONTRIBUTION_TYPE_REIMBURSEMENT._id:
                subTotal = rate;
                break;
        }
    }

    return subTotal;
}
